import React from "react";
import cx from "classnames";
import { FormattedMessage } from "react-intl";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import ceLogo from "../../ce.png";

function PageFooter({ brand, className }) {
  return (
    <div className={cx("Footer", className)}>
      {brand.footerImage && (
        <img
          src={brand.footerImage}
          className="Footer__Image Footer__Image--center"
          alt=""
        />
      )}

      <div className="disclaimer">
        <FormattedMessage id="root.disclaimer" />
      </div>
      <img
        src={brand.ceLogo || ceLogo}
        className="Footer__Image Footer__Image--right"
        alt=""
      />
    </div>
  );
}

PageFooter.propTypes = {
  brand: PropTypes.object.isRequired,
  className: PropTypes.string
};

export default connect(state => ({
  brand: state.brand.settings
}))(PageFooter);



// WEBPACK FOOTER //
// ./src/modules/page/page-footer.js